import { css } from 'lit';

export const styles = css `
  :host([stack][alignment=start]) {
    align-items: flex-start;
  }

  :host([stack][alignment=center]) {
    align-items: center;
  }

  :host([stack][alignment=end]) {
    align-items: flex-end;
  }

  :host([stack]) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;
